import {
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
    Renderer2,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Apollo, gql } from 'apollo-angular';
import { of, Subscription } from 'rxjs';
import * as FontFaceObserver from 'fontfaceobserver';
import { isPlatformBrowser } from '@angular/common';
import {
    ThemeColor,
    primaryThemeColorByEnum,
    secondaryThemeColorByEnum,
} from './shared/theme-color.enum';
import { LoginService } from './shared/login/login-service/login.service';

const query = gql`
    query Query($name: String!) {
        webAccountInfo(name: $name) {
            logo
            headerTitle
            headerSubTitle
            name
            themeColor
            isActive
            customerID
            isUserAccountsEnabled
            creditCardProcessingMethod
            stripeAccountID
        }
    }
`;

@Component({
    selector: 'ols-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    query$: Subscription;
    constructor(
        private apollo: Apollo,
        private titleService: Title,
        private elementRef: ElementRef,
        @Inject(PLATFORM_ID) private platformId: Object,
        private renderer: Renderer2,
        private loginService: LoginService
    ) {}

    async ngOnInit() {
        const defaultThemeColor = primaryThemeColorByEnum[ThemeColor.LightBlue];
        const secondaryThemeColor =
            secondaryThemeColorByEnum[ThemeColor.LightBlue];
        this.query$ = this.apollo
            .watchQuery({
                query,
            })
            .valueChanges.subscribe(
                (response: any) => {
                    //Note: LaunchDarkly flags are not guaranteed to work in here
                    //      since it may not be fully initialized with user data at this time
                    this.setTheme(
                        primaryThemeColorByEnum[
                            response.data.webAccountInfo?.themeColor
                        ] || defaultThemeColor,
                        secondaryThemeColorByEnum[
                            response.data.webAccountInfo?.themeColor
                        ] || secondaryThemeColor
                    );
                    if (response?.data?.webAccountInfo) {
                        if (response.data.webAccountInfo.name?.length) {
                            const title = this.titleService.getTitle();
                            this.titleService.setTitle(
                                `${title} - ${response.data.webAccountInfo.name}`
                            );
                        }
                    }
                },
                (_err) => {
                    this.setTheme(defaultThemeColor, secondaryThemeColor);
                    return of(null);
                }
            );
        if (isPlatformBrowser(this.platformId)) {
            // Avoid flash of icon placeholder text during SSR -> client JS handover.
            const materialIcons = new FontFaceObserver('Material Icons');
            materialIcons
                .load(null, 10000)
                .then(() =>
                    this.renderer.addClass(
                        this.elementRef.nativeElement,
                        'material-icons-loaded'
                    )
                );

            // ...existing client-side-only inits.
        } else {
            // On the server side, add the class to show icons immediately.
            this.renderer.addClass(
                this.elementRef.nativeElement,
                'material-icons-loaded'
            );
        }
    }

    private setTheme(primaryColor, secondaryColor) {
        document.body.style.setProperty('--primary-theme-color', primaryColor);
        document.body.style.setProperty(
            '--secondary-theme-color',
            secondaryColor
        );
    }

    ngOnDestroy() {
        this.query$.unsubscribe();
    }
}
